/*
 * Verifies if a string is a integer and positive
 * @param {string} str - The string to be verified
 * @returns {boolean} - True if the string is a integer and positive, false otherwise
 * @examples
 * isPositiveInteger('1') // true
 * isPositiveInteger('123') // true
 * isPositiveInteger('-1') // false
 * isPositiveInteger('abc') // false
 * isPositiveInteger('1.23') // false
 * isPositiveInteger('') // false
 * isPositiveInteger('0') // false
 */
export const isPositiveInteger = (n: string): boolean => {
  return /^\d+$/.test(n) && parseInt(n) > 0
}
